import React, { useState, useEffect } from 'react'
import ScrollToBottom from 'react-scroll-to-bottom';
import Plus from '../assets/plus.png'

const NoteBook = () => {
    const [inputData, setInputData] = useState('');
    const [noteDataList, setNoteDataList] = useState(localStorage.getItem("storeData") ? JSON.parse(localStorage.getItem("storeData")) : [])

    const handleOnChange = (e) => {
        setInputData(e.target.value)
    }

    const addNoteData = () => {
        if (!inputData) {
            alert('Please enter your note')
        } else {
            setNoteDataList([...noteDataList, inputData]);
            setInputData('')
        }

    }

    const deleteItem = (id) => {
        const UpdateItem = noteDataList.filter((curElem, ind) => {
            return ind !== id
        })
        setNoteDataList(UpdateItem)
    }

    const handleAllRemove = () => {
        setNoteDataList([])
    }

    useEffect(() => {
        localStorage.setItem("storeData", JSON.stringify(noteDataList))
    }, [noteDataList])


    return (
        <>
            <div className='container mb-5' style={{ marginTop: 40 }}>
                <div className='row justify-content-center'>
                    <div className='col-lg-5 col-md-7 col-10'>
                        <div className='text-center'>
                            <h3 className='pb-2'><b><i>Note Your <span style={{ color: 'red' }}>List</span> Here</i></b></h3>
                        </div>
                        <div className='card p-3 card_second mt-3' style={{ borderRadius: 20 }}>
                            <div className='d-flex'>
                                <input type="text" placeholder='Enter your notes' className='form-control note_book' onKeyPress={(e) => e.key === 'Enter' ? addNoteData() : null} value={inputData} onChange={handleOnChange} />
                                <img src={Plus} className='plus_icon ml-1' alt="logo" onClick={addNoteData} />
                                {/* <i className="fa-regular fa-plus plus_icon pl-3 pt-1" onClick={addNoteData}></i> */}
                            </div>
                            <ScrollToBottom className='mt-1 card_final pr-2'>
                                <ol className='navbar-nav'>
                                    {
                                        noteDataList.map((curElem, ind) => (
                                            <div className='card card_input_list py-1 px-2 mt-2 shadow-sm' key={ind}>
                                                <div className='d-flex justify-content-between px-1'>
                                                    {/* row justify-content-between px-3 */}
                                                    <li className='nav-item pl-2'>{curElem}</li>
                                                    <i className="fa-solid fa-trash pt-1 note_cros" onClick={() => deleteItem(ind)}></i>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </ol>
                            </ScrollToBottom>
                            <div className='text-center my-3'>
                                <button className='btn btn__primary px-5' onClick={handleAllRemove}><b>Remove All</b></button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}

export default NoteBook